export const PRODUCT_PLANS = {
  menuEmbed: 'menu_embed',
  starter: 'starter',
} as const;

export type ProductPlan = (typeof PRODUCT_PLANS)[keyof typeof PRODUCT_PLANS];

const PRODUCT_PLAN_ROUTES: Record<ProductPlan, string> = {
  [PRODUCT_PLANS.menuEmbed]: '/sign-up/menu-embed',
  [PRODUCT_PLANS.starter]: '/sign-up/starter',
};

const PRODUCT_PLAN_SLUGS: Record<string, ProductPlan> = {
  'menu-embed': PRODUCT_PLANS.menuEmbed,
  starter: PRODUCT_PLANS.starter,
};

const ALTERNATE_PRODUCT_PLANS: Record<ProductPlan, ProductPlan> = {
  [PRODUCT_PLANS.menuEmbed]: PRODUCT_PLANS.starter,
  [PRODUCT_PLANS.starter]: PRODUCT_PLANS.menuEmbed,
};

export const getProductPlanFromSlug = (slug?: string): ProductPlan | undefined => (
  slug ? PRODUCT_PLAN_SLUGS[slug] : undefined
);

export const getProductPlanRoute = (productPlan: ProductPlan): string => PRODUCT_PLAN_ROUTES[productPlan];

export const getAlternateProductPlan = (productPlan: ProductPlan): ProductPlan => ALTERNATE_PRODUCT_PLANS[productPlan];
